<template>
    <QueueDisplay :total="count">
        <template v-slot:icon>
          <OfficeBuildingIcon />
        </template>
    </QueueDisplay>
</template>

<script>
import { ref, onMounted, onUnmounted, watch } from 'vue'
import QueueDisplay from "@/components/ui/QueueDisplay.vue"
import {OfficeBuildingIcon} from "@heroicons/vue/solid"
import api from "@/api"

export default {
  components:{QueueDisplay,OfficeBuildingIcon},
  emits:['count'],
  setup(props, { emit }) {
    const count = ref(0)

  // Watchers
    watch(count, (value) => emit('count', Number(value) || 0), { immediate: true })

    onMounted(()=>{
      getInitialCount()
      joinRoom()
      window.addEventListener("socket_connected", handleReconnect)
      window.addEventListener("integrator_forms_queue", handleWebSocketData)
    })

    onUnmounted(()=>{
      window.removeEventListener("socket_connected", handleReconnect)
      window.removeEventListener("integrator_forms_queue", handleWebSocketData)
    })

    const handleWebSocketData = (e)=>{
      const data = Number(e.detail?.data)
      if (isNaN(data)) {
        count.value = 0;
      } else {
        count.value = data
      }
    }

    const getInitialCount = async ()=>{
      await api
      .get("integratorFormRequests/openCount")
      .then((res)=>{
        res.data?.data && Number(res.data.data) ? count.value = Number(res.data.data) : null
      })
      .catch((err)=>{
        console.error(err.response?.data?.error || err.message)
      })
    }
    const joinRoom = ()=>{
      let eventJoin = new CustomEvent("requestRoom", {detail: { route: "integrator_forms", room: "integrator_forms_queue" }});
      dispatchEvent(eventJoin);
    }

    const handleReconnect = ()=>{
      joinRoom()
    }

    return {
      count
    }
  }
}
</script>

<style scoped>
</style>